import React from "react";
import "./style.css";

import Skeleton from "../Skeleton/Skeleton";

const PublicationPreviewSkeleton = ({ no_border = true }) => (
    <div className="publication-preview" no_border={String(no_border)}>
        <Skeleton style={{ height: "1em", width: "95%", marginBottom: "0.4em" }} />
        <Skeleton style={{ height: "1em", width: "80%" }} />
    </div>
);

export default PublicationPreviewSkeleton;
